import React, { useState } from "react";
import "./ExpenseForm.css";

const ExpenseForm = (props) => {
  const [changeTitle, setChangeTitle] = useState("");
  const [changeAmount, setChangeAmount] = useState("");
  const [changeDate, setChangeDate] = useState("");
  const [show, setShow] = useState(true);
  const [cancel, setCancel] = useState(true);

  const handleChange = (event) => {
    setChangeTitle(event.target.value);
    // console.log(event.target.value);
  };

  const handleAmount = (event) => {
    setChangeAmount(event.target.value);
    // console.log(event.target.value);
  };

  const handleDate = (event) => {
    setChangeDate(event.target.value);
    // console.log(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const expenseData = {
      title: changeTitle,
      amount: +changeAmount,
      date: new Date(changeDate),
    };

    props.onExpenseHandler(expenseData);
    setChangeTitle("");
    setChangeAmount("");
    setChangeDate("");
    setShow(true);
  };

  const handleAddNewBtn = () => {
    if(show){
      setShow(false)
    }else{
      setShow(true)
    }
  };

  const handleCancelBtn = () => {
    if(cancel){
      setShow(true)
    }
  }

  return (
    <>
      {show ? (
        <button onClick={handleAddNewBtn}>Add New Expense</button>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="new-expense__controls">
            <div className="new-expense__control">
              <label>Title</label>
              <input onChange={handleChange} type="text" value={changeTitle} />
            </div>
            <div className="new-expense__control">
              <label>Amount</label>
              <input
                onChange={handleAmount}
                type="number"
                min="0.01"
                step="0.01"
                value={changeAmount}
              />
            </div>
            <div className="new-expense__control">
              <label>Date</label>
              <input
                onChange={handleDate}
                type="date"
                min="2020-01-01"
                max="2023-12-31"
                value={changeDate}
              />
            </div>
          </div>
          <div className="new-expense__actions">
            <button type='button' onClick={handleCancelBtn}>Cancel</button>
            <button type="submit">Add Expense</button>
          </div>
        </form>
      ) }
    </>
  );
};

export default ExpenseForm;
